interface TrainingHeroProps {
  onFindCoachClick: () => void;
}

export default function TrainingHero({ onFindCoachClick }: TrainingHeroProps) {
  const handleBrowsePrograms = () => {
    const programsSection = document.getElementById('coaching-programs');
    if (programsSection) {
      programsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900/30 to-gray-900">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-10"></div>
        </div>
      </div>
      
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9a26ac3d4886fb435595a940d87ded5d.jpg"
          alt="Training"
          className="w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-purple-900/40 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl">
        <div className="inline-flex items-center bg-purple-600/20 border border-purple-500/50 rounded-full px-5 py-2 mb-6 backdrop-blur-sm">
          <i className="ri-trophy-line text-purple-400 mr-2"></i>
          <span className="text-purple-300 font-semibold text-sm">ELITE TRAINING PROGRAMS</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Level Up Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Skills</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          Train with professional coaches, master advanced techniques, and dominate the competition. 
          Our comprehensive training programs are designed for players of all skill levels.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={onFindCoachClick}
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg shadow-purple-500/50 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-search-line mr-2"></i>
            Find a Coach
          </button>
          <button 
            onClick={handleBrowsePrograms}
            className="bg-gray-800/80 backdrop-blur-sm border-2 border-purple-500/50 text-purple-300 hover:bg-purple-600 hover:text-white hover:border-purple-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line mr-2"></i>
            Browse Programs
          </button>
        </div>
      </div>
    </section>
  );
}
